"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootClass = void 0;
var flApi = require("./flApi");
var rh = require("./rootHelpers");
var f = {
    checkData: rh.RootHelpers.checkData,
    concat: rh.RootHelpers.jsonConcat,
    getTranscod: rh.RootHelpers.getTranscod,
    isFieldObject: rh.RootHelpers.isFieldObject,
};
var RootClass = (function () {
    function RootClass(typeObj, jSonDoc, srvType) {
        var _this = this;
        if (srvType === void 0) { srvType = 1; }
        this.myApi = flApi.Api.getInstance();
        this.myJSonVal = {};
        this.mySrvType = srvType;
        this.myTypeObj = typeObj;
        var isJsonData = jSonDoc.eCN === undefined;
        if (f.isFieldObject(typeObj)) {
            this.myECN = 0;
            var tmpECN = isJsonData ?
                jSonDoc.c1 :
                jSonDoc.eCN;
            if (this.myApi.getObject(tmpECN) === null) {
                throw new Error("invalid Entity: " + tmpECN);
            }
        }
        else {
            this.myECN = isJsonData ?
                jSonDoc.c1 :
                jSonDoc.eCN;
        }
        this.forceLocalValues();
        this.myTranscod = f.getTranscod(typeObj);
        this.myTranscod.forEach(function (aKey) {
            Object.defineProperty(_this, aKey.name, {
                configurable: true,
                enumerable: true,
                get: function () {
                    if (_this.myJSonVal[aKey.name] === undefined) {
                        _this.myJSonVal[aKey.name] = aKey.default;
                    }
                    switch (typeof aKey.type) {
                        case "boolean":
                            if (_this.myJSonVal[aKey.name] === 1) {
                                return true;
                            }
                            return false;
                        default:
                            return _this.myJSonVal[aKey.name];
                    }
                },
                set: function (newVal) {
                    var myVal = { data: newVal };
                    f.checkData(aKey, myVal, _this);
                    _this.myJSonVal[aKey.name] = myVal.data;
                },
            });
            if (jSonDoc[aKey.cn] !== undefined) {
                isJsonData = true;
                _this.myJSonVal[aKey.name] = jSonDoc[aKey.cn];
            }
            else {
                if (jSonDoc[aKey.name] !== undefined) {
                    isJsonData = false;
                    _this.myJSonVal[aKey.name] = jSonDoc[aKey.name];
                }
            }
            if (aKey.cn === "c7") {
                _this[aKey.name] = typeObj.toString();
            }
        });
        if (f.isFieldObject(typeObj)) {
            Object.defineProperty(this, "fcnbb", {
                configurable: true,
                enumerable: true,
                get: function () {
                    if (["linkedField", "rollup"].indexOf(_this.systemType) !== -1) {
                        return "d" + _this.id;
                    }
                    return "c" + _this.id;
                },
                set: function () {
                    throw new Error("not allowed");
                },
            });
            Object.defineProperty(this, "fcn", {
                configurable: true,
                enumerable: true,
                get: function () {
                    return _this.id;
                },
                set: function () {
                    throw new Error("not allowed");
                },
            });
        }
        if (isJsonData) {
            this.encode(jSonDoc);
        }
    }
    Object.defineProperty(RootClass.prototype, "myECN", {
        get: function () {
            return this.myJSonVal.c1;
        },
        set: function (newECN) {
            this.myJSonVal.c1 = newECN;
        },
        enumerable: false,
        configurable: true
    });
    RootClass.prototype.encode = function (jData) {
        var _this = this;
        try {
            this.myTranscod.forEach(function (aKey) {
                try {
                    if (aKey.subField.length === 0) {
                        if (jData[aKey.cn] !== undefined) {
                            _this[aKey.name] = jData[aKey.cn];
                        }
                        else {
                            if (jData[aKey.name] !== undefined) {
                                _this[aKey.name] = jData[aKey.name];
                            }
                        }
                    }
                    else {
                        if (aKey.type instanceof Array) {
                            _this[aKey.name] = [];
                            if (jData[aKey.cn] !== undefined &&
                                jData[aKey.cn] !== null &&
                                jData[aKey.cn] instanceof Array) {
                                jData[aKey.cn].forEach(function (aDataItem) {
                                    _this[aKey.name].push({});
                                    _this.encodeRecurse(aKey.subField, _this[aKey.name][_this[aKey.name].length - 1], aDataItem);
                                });
                            }
                            else {
                                console.error("invalid data, not an array: " + aKey.cn + ", data ignored");
                            }
                        }
                        else {
                            _this[aKey.name] = {};
                            _this.encodeRecurse(aKey.subField, _this[aKey.name], _this[aKey.cn]);
                        }
                    }
                }
                catch (err) {
                    console.error(err.stack || err);
                }
            });
            this.forceLocalValues();
            return this;
        }
        catch (err) {
            console.error(err.stack || err);
            if (err.stack === undefined) {
                throw new Error(err);
            }
            else {
                throw err;
            }
        }
    };
    RootClass.prototype.decode = function () {
        var _this = this;
        var tmpJson = {};
        try {
            this.myTranscod.forEach(function (aKey) {
                try {
                    if (aKey.subField.length === 0) {
                        if (_this[aKey.name] !== undefined) {
                            tmpJson[aKey.cn] = _this[aKey.name];
                        }
                    }
                    else {
                        if (aKey.type instanceof Array) {
                            tmpJson[aKey.cn] = [];
                            if (_this[aKey.name] !== undefined &&
                                _this[aKey.name] !== null &&
                                _this[aKey.name] instanceof Array) {
                                tmpJson[aKey.cn] = [];
                                _this[aKey.name].forEach(function (aDataItem) {
                                    tmpJson[aKey.cn].push({});
                                    _this.decodeRecurse(aKey.subField, tmpJson[aKey.cn][tmpJson[aKey.cn].length - 1], aDataItem);
                                });
                            }
                            else {
                                console.error("invalid data, not an array: " + aKey.name + ", data ignored");
                            }
                        }
                        else {
                            tmpJson[aKey.cn] = {};
                            _this.decodeRecurse(aKey.subField, tmpJson[aKey.cn], _this[aKey.name]);
                        }
                    }
                }
                catch (err) {
                    console.error(err.stack || err);
                }
            });
            return tmpJson;
        }
        catch (err) {
            console.error(err.stack || err);
            if (err.stack === undefined) {
                throw new Error(err);
            }
            else {
                throw err;
            }
        }
    };
    RootClass.prototype.delete = function (options) {
        if (options === void 0) { options = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.myApi.restApi.deleteOneDocument(this.myECN, this.id, options.replace("noErrDisp", ""), this.mySrvType)];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (options.indexOf("noErrDisp") === -1) {
                            console.error(err_1.stack || err_1);
                        }
                        err_1 = err_1.stack === undefined ? new Error(err_1) : err_1;
                        throw err_1;
                    case 3: return [2];
                }
            });
        });
    };
    RootClass.prototype.setProp = function (propName, value) {
        return __awaiter(this, void 0, void 0, function () {
            var tmpObj, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (propName.indexOf(".") !== -1) {
                            throw new Error("setProp used with " + propName);
                        }
                        this[propName] = value;
                        return [4, this.save()];
                    case 1:
                        tmpObj = _a.sent();
                        return [2, [tmpObj]];
                    case 2:
                        err_2 = _a.sent();
                        err_2 = err_2.stack === undefined ? new Error(err_2) : err_2;
                        throw err_2;
                    case 3:
                        ;
                        return [2];
                }
            });
        });
    };
    RootClass.prototype.save = function (forcedEcn) {
        if (forcedEcn === void 0) { forcedEcn = -1; }
        return __awaiter(this, void 0, void 0, function () {
            var updDoc, err_3, oldJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4, this.myApi.restApi.replaceDocument((forcedEcn === -1) ? this.myECN : forcedEcn, this.decode(), "", this.mySrvType)];
                    case 1:
                        updDoc = _a.sent();
                        switch (updDoc.length) {
                            case 0:
                                console.log("save updated no document ???? " + JSON.stringify(this.myJSonVal));
                                return [2, this];
                            case 1:
                                return [2, this.encode(updDoc[0])];
                            default:
                                throw new Error("update affected more than one document ???? " + JSON.stringify(updDoc));
                        }
                        return [3, 4];
                    case 2:
                        err_3 = _a.sent();
                        return [4, this.myApi.getOneDocument(this.myECN, this.id, "", false, this.mySrvType)];
                    case 3:
                        oldJson = _a.sent();
                        this.encode(oldJson[0]);
                        console.error(err_3.stack || err_3);
                        err_3 = err_3.stack === undefined ? new Error(err_3) : err_3;
                        throw err_3;
                    case 4:
                        ;
                        return [2];
                }
            });
        });
    };
    RootClass.prototype.dump = function (myIdent, bDumpName, bDisplay) {
        var _this = this;
        if (myIdent === void 0) { myIdent = 0; }
        if (bDumpName === void 0) { bDumpName = true; }
        if (bDisplay === void 0) { bDisplay = false; }
        var identRef = "                             ";
        if (myIdent > 30) {
            myIdent = 30;
        }
        var dumpStr = "";
        this.myTranscod.forEach(function (aKey) {
            dumpStr += identRef.substr(0, myIdent);
            dumpStr += (bDumpName) ? (aKey.name + ": ") : (aKey.cn + ": ");
            dumpStr += (typeof (aKey.type) === "boolean") ?
                (_this.myJSonVal[aKey.name] ? "true\n" : "false\n") :
                (JSON.stringify(_this.myJSonVal[aKey.name]) + "\n");
        });
        if (bDisplay) {
            console.error(dumpStr.substr(0, dumpStr.length - 1));
        }
        dumpStr = dumpStr.substr(0, dumpStr.length - 1);
        if (this._field instanceof Array) {
            this._field.forEach(function (aFiFi) {
                dumpStr += aFiFi.dump(myIdent + 2, bDumpName, bDisplay);
            });
        }
        return dumpStr;
    };
    RootClass.prototype.postProcess = function () {
        ;
    };
    RootClass.prototype.toClass = function () {
        return this;
    };
    RootClass.prototype.encodeRecurse = function (subKeySet, jDocToWrite, jSonToDecode) {
        subKeySet.forEach(function (aKey) {
            jDocToWrite[aKey.name] = jSonToDecode[aKey.cn];
        });
    };
    RootClass.prototype.decodeRecurse = function (subKeySet, jSonToWrite, jDocToDecode) {
        subKeySet.forEach(function (aKey) {
            jSonToWrite[aKey.cn] = jDocToDecode[aKey.name];
        });
    };
    RootClass.prototype.forceLocalValues = function () {
        switch (this.myTypeObj) {
            case "application":
                this.myECN = 60;
                this.mySrvType = 2;
                break;
            case "user":
                this.myECN = 50;
                this.mySrvType = 2;
                break;
            case "entity":
                this.myECN = 0;
                break;
        }
    };
    return RootClass;
}());
exports.RootClass = RootClass;
